import "./modal.component.css";
import modalWrapperTemplate from "./modal.component.handlebars";
import "tingle.js/dist/tingle.min.css";

import Handlebars from "handlebars";
// import scrollLock from "scroll-lock";
import tingle from "tingle.js";
import { LanguageService } from "src/js/services/language-service";
import { QueryService } from "src/js/services/query-service";
import { pipe } from "fp-ts/lib/function";
import { array, option, string } from "fp-ts";

const modalWrapperRenderer = Handlebars.compile(modalWrapperTemplate);

export class ModalComponent {
  static languageService: LanguageService;
  static queryService: QueryService;

  private static modalIdentitiesQueryKey = "_m";
  static configure(languageService: LanguageService) {
    ModalComponent.languageService = languageService;
    ModalComponent.queryService = new QueryService();

    // Clear the "_m" query param on page load untill we can open the list of modals
    ModalComponent.queryService.remove(ModalComponent.modalIdentitiesQueryKey);
  }

  private static pushIdentity(identity: string) {
    const modalIdentities: string[] = pipe(
      ModalComponent.queryService.getArray(
        ModalComponent.modalIdentitiesQueryKey
      ),
      option.getOrElse(() => [] as string[]),
      array.filter((id) => string.isEmpty(id) === false),
      array.append(identity)
    );

    ModalComponent.queryService.setArray(
      ModalComponent.modalIdentitiesQueryKey,
      modalIdentities
    );
  }

  private static popIdentity() {
    const modalIdentities: string[] = pipe(
      ModalComponent.queryService.getArray(
        ModalComponent.modalIdentitiesQueryKey
      ),
      option.getOrElseW(() => []),
      array.dropRight(1)
    );

    ModalComponent.queryService.setArray(
      ModalComponent.modalIdentitiesQueryKey,
      modalIdentities
    );
  }

  private static _openModal(
    contentHtml: string,
    clientSpecificClass: string,
    onClose: () => void,
    beforeClose?: () => boolean
  ): tingle.modal {
    const modalHtml = modalWrapperRenderer({ content: contentHtml });

    const cssClasses = ["ug", "app", "modal"];
    if (clientSpecificClass) {
      cssClasses.push(clientSpecificClass);
    }

    const modal = new tingle.modal({
      cssClass: cssClasses,
      closeMethods: ["overlay", "button", "escape"],
      beforeClose: function () {
        if (beforeClose) {
          return beforeClose();
        }
        return true; // Allow closing by default
      },
      onClose: function () {
        onClose();
        modal.destroy();
      },

      closeLabel: ModalComponent.languageService.getTranslations().modal.close,
    });
    modal.setContent(modalHtml);
    modal.open();
    modal
      .getContent()
      .querySelector(".modal_close")
      ?.addEventListener("click", () => modal.close());

    setTimeout(() => modal.checkOverflow(), 100);

    return modal;
  }

  static openModal(
    contentHtml: string,
    clientSpecificClass: string
  ): tingle.modal {
    return this._openModal(contentHtml, clientSpecificClass, () => {});
  }

  static openModalWithUrlState(
    contentHtml: string,
    clientSpecificClass: string,
    identity: string,
    beforeClose?: () => boolean
  ): tingle.modal {
    this.pushIdentity(identity);
    const onClose = this.popIdentity;
    return this._openModal(
      contentHtml,
      clientSpecificClass,
      onClose,
      beforeClose
    );
  }
}
